import React from 'react';
import classNames from 'classnames';
import { Link as ReactRouterLink, LinkProps as ReactRouterLinkProps } from 'react-router-dom';

import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';

import { PagePath, pagePathToPathString } from 'services/base/page_path';

import baseStyles from './link.module.css';

type LinkStyles = {
  disabledLink: string;
};

const themedStyles: ThemedStyles<LinkStyles> = {
  [Theme.DAYLIGHT]: {
    disabledLink: baseStyles.disabledLink,
  },
  [Theme.MIDNIGHT]: {
    disabledLink: baseStyles.disabledLink,
  },
};

type LinkProps = Omit<ReactRouterLinkProps & { path: PagePath; disabled?: boolean }, 'to'>;

export const Link = ({ path, disabled, ...props }: LinkProps) => {
  const styles = useStyles(themedStyles);
  if (disabled) {
    return(
      <span className={classNames(props.className, styles.disabledLink)}>
        {props.children}
      </span>
    );
  } else {
    return(
      <ReactRouterLink {...props} to={pagePathToPathString(path)} />
    );
  }
};
